import { motion } from "framer-motion";
import {
  UtensilsCrossed, Gem, Martini, Leaf, Bike, PartyPopper, HeartHandshake, Moon,
} from "lucide-react";
import Reveal from "./Reveal";
import { WHY_CHOOSE } from "@/data/content";

const ICONS = { UtensilsCrossed, Gem, Martini, Leaf, Bike, PartyPopper, HeartHandshake, Moon };

// Asymmetric spans for bento tension
const SPANS = [
  "md:col-span-2 md:row-span-1",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
];

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="relative bg-[#0D0D0D] py-24 md:py-32 px-6 md:px-10 border-t border-[#C8A24A]/10">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="text-center mb-16">
          <p className="text-[#C8A24A] uppercase text-xs tracking-[0.35em] mb-4">The Ekaa Difference</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
            Why Dine <span className="italic text-gold-gradient">With Us</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 auto-rows-[190px]">
          {WHY_CHOOSE.map((f, i) => {
            const Icon = ICONS[f.icon] || Gem;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ rotateX: 4, rotateY: -4 }}
                style={{ transformStyle: "preserve-3d" }}
                data-testid={`why-card-${i}`}
                className={`hover-gold-glow group relative bg-[#181818] border border-[#C8A24A]/15 rounded-sm p-7 flex flex-col justify-between overflow-hidden ${SPANS[i]}`}
              >
                <div className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-[#C8A24A]/5 blur-2xl group-hover:bg-[#C8A24A]/15 transition-all" />
                <div className="h-12 w-12 flex items-center justify-center border border-[#C8A24A]/30 rounded-sm text-[#C8A24A] group-hover:bg-[#C8A24A] group-hover:text-[#0D0D0D] transition-all">
                  <Icon className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="font-display text-2xl text-white mb-1.5">{f.title}</h3>
                  <p className="text-[#D6D6D6]/80 font-light text-sm leading-relaxed">{f.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
